import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';
import images from './images';

registerImages('registration', images);

declare global {
  interface RegisteredImages {
    registration: Record<keyof typeof images, ImageSource>;
  }
}
